import appInfo from '@/app-info'
import axios from 'axios'
import router from '@/router'

const emptyData = {
  VarName: '',
  VarType: 'constant_master',
  Source_1: '0'
}

var validateName = async (name) => {
  var id = router.history.current.params.id
  var idFormula = ''

  if (id) {
    idFormula = `&idFormula=${id}`
  }

  try {
    const res = await axios.get(
      appInfo.api.formula.isAvailableVarNameFormula +
        '?varName=' +
        name +
        idFormula
    )
    return res.data
  } catch (e) {
    console.log(e)
  }
}

var validateVarName = async (rule, value, callback) => {
  if (value == '') {
    callback(new Error('Contanta Name is required'))
  } else if (!(await validateName(value))) {
    callback(new Error('Contanta Name already used'))
  } else {
    callback()
  }
}

const validationRules = {
  VarName: [
    {
      required: true,
      trigger: 'blur',
      validator: validateVarName
    }
  ],
  Source_1: [
    {
      required: true,
      message: 'Contanta Value is required',
      trigger: 'blur'
    }
  ]
}

export default {
  getEmptyData() {
    return emptyData
  },
  getValidationRule() {
    return validationRules
  }
}
